// Package Imports
import { Route } from 'react-router-dom';
import React, { lazy, Suspense } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const QueryConfig = lazy(() => import('pages/QueryConfig/QueryConfig'));
const QueryConfigCreate = lazy(
  () => import('pages/QueryConfig/QueryConfigCreate')
);

const QueryConfigRoute = (
  <Route path={routeName.Query}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.QUERY_VIEW,
            PrivateRouteConst.SELF_QUERY_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <QueryConfig />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.CREATE_QUERY}>
          <Suspense fallback={<Loading />}>
            <QueryConfigCreate type="Create" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.QUERY_EDIT,
            PrivateRouteConst.SELF_QUERY_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <QueryConfigCreate type="Edit" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.QUERY_VIEW,
            PrivateRouteConst.SELF_QUERY_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <QueryConfigCreate type="Show" />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default QueryConfigRoute;
